import { call, select, put, all, takeLatest } from "redux-saga/effects";
import {
  selectFormReqLeave,
  selectRequestLeaveDetailData,
} from "../redux/selector";
import {
  updateLeaveMaternityOrderFailed,
  updateLeaveMaternityOrderStart,
  updateLeaveMaternityOrderSuccess,
} from "../redux/updateLeaveMaternityOrder";
import { toast } from "react-toastify";
import {
  formReqLeaveReset,
  resetFormLeaveLongTerm,
} from "../redux/formReqLeave";
import { updateLeaveMaternityOrderApi } from "core/http/service/employeeRequest";

function* updateLeaveMaternityOrderWork(action) {
  const { screenCode } = action.payload;
  const { longTerm } = yield select(selectFormReqLeave);
  const dataDetail = yield select(selectRequestLeaveDetailData);
  try {
    const newFormData = {
      id: dataDetail?.id || undefined,
      details: [
        {
          fromDate: longTerm?.fromDate?.toISOString(),
          toDate: longTerm?.toDate?.toISOString(),
        },
      ],
    };
    const res = yield call(
      updateLeaveMaternityOrderApi,
      screenCode,
      newFormData
    );
    if (res) {
      yield put({
        type: updateLeaveMaternityOrderSuccess.type,
      });
      yield put({
        type: resetFormLeaveLongTerm.type,
      });
      yield put({
        type: formReqLeaveReset.type,
      });
      action.payload?.callback?.();
      toast.success(`Đơn xin nghỉ của bạn đã được cập nhật thành công`);
    }
  } catch (err: any) {
    yield put({
      type: updateLeaveMaternityOrderFailed.type,
    });

    toast.error(err?.response?.data?.message || "Đã có lỗi xảy ra !");
  }
}

function* watchUpdateLeaveMaternityOrder() {
  yield takeLatest(
    updateLeaveMaternityOrderStart.type,
    updateLeaveMaternityOrderWork
  );
}

export default function* updateLeaveMaternityOrderSaga() {
  yield all([watchUpdateLeaveMaternityOrder()]);
}
